<div id="find-user" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="maint-title bold color-grey uk-text-uppercase">
                    Ajouter un nouveau <br>utilisateur
                </h2>

                <!-- Society picker (super-admin only) -->
                <div class="uk-margin" *ngIf="showSocietyPicker">
                    <label class="label">Opérateur</label>
                    <div class="uk-form-controls uk-margin-small-top">
                        <select class="input alt bold color-cold-grey uk-width-1-1"
                            [ngModel]="selectedSocietyId"
                            (ngModelChange)="onSocietyChange($event)">
                            <option [value]="0">— Sélectionner un opérateur —</option>
                            <option *ngFor="let s of societies" [value]="s.Id">{{ s.Name }} ({{ s.Code }})</option>
                        </select>
                    </div>
                </div>

                <div class="uk-margin">
                    <label class="label">Rechercher un utilisateur</label>
                    <div class="uk-form-controls uk-margin-small-top uk-position-relative">
                        <span *ngIf="loading === false" class="uk-form-icon uk-form-icon-flip" style="top: -5px;">
                            <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                        </span>
                        <span *ngIf="loading === true" class="uk-form-icon uk-form-icon-flip">
                            <div style="width:24px; height: 24px;" uk-spinner></div>
                        </span>
                        <input class="input alt bold color-cold-grey uk-width-1-1" type="text" [(ngModel)]="userSearch"
                            (ngModelChange)="updateUserOptionList($event)"
                            (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                            [disabled]="showSocietyPicker && selectedSocietyId === 0"
                            placeholder="John Doe"
                        >
                        <div [class.display-none]="userDisplay === false || loading === true" class="suggestions">
                            <div [class.display-none]="userOptions.length === 0" class="arrow"></div>
                            <div [class.display-none]="noResult === false">
                                Pas de résultats
                            </div>
                            <div [class.display-none]="noResult === true && false" *ngFor="let option of userOptions"
                                (click)="setUserSearch(option)"
                            >
                                {{ option.FirstName }} {{ option.LastName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-grid-small modal-gray-part">
                    <div *ngIf="userSet === false">
                        Aucun utilisateur sélectionné.
                    </div>
                    <div *ngIf="userSet === true">
                        <div class="uk-margin-small-left uk-margin-small-bottom">Vous avez sélectionné</div>
                        <img src="../../../assets/icons/User.svg" width="40px" height="40px" alt="user"/>
                        <span class="bold uk-margin-small-left">{{ user.FirstName }} {{ user.LastName }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="userSet === false || (showSocietyPicker && selectedSocietyId === 0)"
                    (click)="sendUser()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div>
